import { PropertyModel } from 'common/data/property/model';
import { DataStore } from 'common/module/data/store';
import { PropertyCallTooltipTemplatePropsInterface } from 'desktop/module/property/call-tooltip/template-props.interface';
import { PropertyCallTooltipViewStoreEvent } from 'desktop/module/property/call-tooltip/view-store.event';

export class PropertyCallTooltipViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: PropertyCallTooltipTemplatePropsInterface = {
    model: null,
    onClickClose: this.onClickClose.bind(this),
  };

  /**
   * @inheritDoc
   */
  public getState(): PropertyCallTooltipTemplatePropsInterface {
    return this.state;
  }

  /**
   * Update the model associated with the tooltip
   */
  public updateModel(model: PropertyModel): void {
    this.setState({
      ...this.getState(),
      model,
    });
  }

  /**
   * Clicked close
   */
  private onClickClose(e: Event): void {
    e.preventDefault();
    e.stopPropagation();

    this.getEventEmitter().emit(PropertyCallTooltipViewStoreEvent.clickClose);
  }
}
